import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { expenseCategoryActions } from "../slices/expenseCategory";
import { getErrorMessage } from "../../utils/errorUtils";
import { ExpenseCategoryRequestDto } from "../../shared/dtos/expenseCategory/ExpenseCategoryRequestDto";
import { ExpenseCategoryResponseDto } from "../../shared/dtos/expenseCategory/ExpenseCategoryResponseDto";
import { UpdateExpenseCategoryPayload } from "../../shared/interfaces/expenseCategory/UpdateExpenseCategoryPayload";
import { PaginationQueryDto } from "../../shared/dtos/common/PaginationQueryDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getExpenseCategories =
  (params?: PaginationQueryDto) => async (dispatch: AppDispatch) => {
    dispatch(expenseCategoryActions.setLoadingFetchAll());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<ExpenseCategoryResponseDto>>
      >("/expense-categories", {
        headers: { requiresAuth: true },
        params,
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(expenseCategoryActions.setItems(data.data.content));
        dispatch(expenseCategoryActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(expenseCategoryActions.setErrorFetchAll(getErrorMessage(error)));
    }
  };

export const createExpenseCategory =
  (values: ExpenseCategoryRequestDto) => async (dispatch: AppDispatch) => {
    dispatch(expenseCategoryActions.setLoadingCreate());
    try {
      const { data } = await axiosInstance.post<
        ApiResponseDto<ExpenseCategoryResponseDto>
      >("/expense-categories", values, {
        headers: { requiresAuth: true },
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Category created!");
        dispatch(expenseCategoryActions.createSuccess(data.data));
        dispatch(
          expenseCategoryActions.setServerStatus({
            operation: "create",
            status: data.statusCode || 201,
          }),
        );
      }
    } catch (error) {
      dispatch(expenseCategoryActions.setErrorCreate(getErrorMessage(error)));
    }
  };

export const updateExpenseCategory =
  (payload: UpdateExpenseCategoryPayload) => async (dispatch: AppDispatch) => {
    dispatch(expenseCategoryActions.setLoadingUpdate());
    try {
      const { data } = await axiosInstance.put<
        ApiResponseDto<ExpenseCategoryResponseDto>
      >(`/expense-categories/${payload.id}`, payload.values, {
        headers: { requiresAuth: true },
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Category updated!");
        dispatch(expenseCategoryActions.updateSuccess(data.data));
        dispatch(
          expenseCategoryActions.setServerStatus({
            operation: "update",
            status: data.statusCode || 200,
          }),
        );
      }
    } catch (error) {
      dispatch(expenseCategoryActions.setErrorUpdate(getErrorMessage(error)));
    }
  };

export const deleteExpenseCategory =
  (id: string) => async (dispatch: AppDispatch) => {
    dispatch(expenseCategoryActions.setLoadingDelete());
    try {
      const { data } = await axiosInstance.delete<ApiResponseDto<void>>(
        `/expense-categories/${id}`,
        {
          headers: { requiresAuth: true },
        },
      );
      if (data.status === ApiResponseStatus.SUCCESS) {
        toast.success(data.message || "Category deleted!");
        dispatch(expenseCategoryActions.deleteSuccess(id));
      }
    } catch (error) {
      dispatch(expenseCategoryActions.setErrorDelete(getErrorMessage(error)));
    }
  };
